
  window.addEventListener('DOMContentLoaded', function () {
    const audio = document.getElementById('musicaFondo');

    const iniciarMusica = (e) => {
      // Evitar que se active si se hizo clic en un video o su botón
      if (
        e.target.closest('.video-wrapper') ||
        e.target.classList.contains('custom-video') ||
        e.target.classList.contains('play-button')
      ) {
        return;
      }

      audio.volume = 1; // Volumen máximo
      audio.play();

      // Fade out a los 14s
      setTimeout(() => {
        const intervalo = setInterval(() => {
          if (audio.volume > 0.05) {
            audio.volume -= 0.05;
          } else {
            audio.volume = 0;
            audio.pause();
            audio.currentTime = 0;
            clearInterval(intervalo);
          }
        }, 200);
      }, 14000);

      document.removeEventListener('click', iniciarMusica);
    };

    document.addEventListener('click', iniciarMusica);
  });

  // Script para los videos
  document.querySelectorAll('.video-wrapper').forEach(wrapper => {
    const video = wrapper.querySelector('.custom-video');
    const playBtn = wrapper.querySelector('.play-button');

    playBtn.addEventListener('click', () => {
      video.controls = true;
      video.play();
      playBtn.style.display = 'none';
    });

    video.addEventListener('pause', () => {
      if (!video.ended) {
        playBtn.style.display = 'block';
        video.controls = false;
      }
    });

    video.addEventListener('ended', () => {
      playBtn.style.display = 'block';
      video.controls = false;
    });
  });


  document.getElementById('numeros').addEventListener('click', () => {
    const texto = document.getElementById('numerosh2').innerText;
    const primerNumero = texto.split('-')[0].trim(); // Extrae el primer número

    navigator.clipboard.writeText(primerNumero).then(() => {
      // Feedback visual opcional
      const original = document.getElementById('numerosh2').innerText;
      document.getElementById('numerosh2').innerText = '¡Número copiado!';
      setTimeout(() => {
        document.getElementById('numerosh2').innerText = original;
      }, 3000);
    }).catch(err => {
      console.error('Error al copiar:', err);
    });
  });


